import React, { FC } from 'react'
import GlobalContainer from '../globalContainer'
import Typography from '../typography'
import { RelatedCustomerStoriesContainer } from './style'
import { GenerateCard } from './utils/builder'

type Props = {
  data: any
}

const RelatedCustomerStories: FC<Props> = ({ data }) => {
  if (!data) return null
  const customerStoryMicrocopy = data.length && data[0].customerStoryMicrocopy?.values
  let sectionTitle: string = ''

  if (customerStoryMicrocopy) {
    let relatedTextSet = customerStoryMicrocopy.filter(
      (item: any) => item.key?.includes('stories') && item.key?.includes('relatedText')
    )

    sectionTitle = relatedTextSet && relatedTextSet[0] && relatedTextSet[0].value
  }

  return (
    <RelatedCustomerStoriesContainer data-cy="RelatedCustomerStories">
      {sectionTitle && <Typography type="header2">{sectionTitle}</Typography>}
      <GlobalContainer className="RelatedCustomerStories">
        {data.map((story: any, idx: number) => (
          <GenerateCard key={`RelatedCustomerStories-${idx}`} item={story} />
        ))}
      </GlobalContainer>
    </RelatedCustomerStoriesContainer>
  )
}

export default RelatedCustomerStories
